import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Twitter } from "lucide-react";
import { stakeUrl } from "../lib/stake";

const DISCORD_URL = "https://discord.gg/YKh5ZUpgER";
const TWITTER_URL = "https://x.com/gumbleonline";

export default function Footer() {
  return (
    <footer className="relative px-6 md:px-10 pt-10 pb-14" data-testid="site-footer">
      <div className="max-w-6xl mx-auto glass rounded-[32px] p-8 md:p-10 relative overflow-hidden">
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-white/[0.04] blur-3xl rounded-full pointer-events-none" />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <img src="/logo.png" alt="Gumble" className="h-7 w-auto" />
            <p className="mt-5 text-[13.5px] text-white/50 leading-relaxed max-w-md">
              An independent studio building bold, math-first titles. Games available exclusively on Stake.
            </p>
            <div className="mt-6 flex items-center gap-2">
              <a href={DISCORD_URL} target="_blank" rel="noreferrer" title="Join our Discord" data-testid="footer-discord"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full glass hover:bg-white/10 transition-colors">
                <MessageCircle className="w-4 h-4 text-white/80" />
              </a>
              <a href={TWITTER_URL} target="_blank" rel="noreferrer" title="Follow on X" data-testid="footer-twitter"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full glass hover:bg-white/10 transition-colors">
                <Twitter className="w-4 h-4 text-white/80" />
              </a>
              <a href={stakeUrl("/fr/casino/group/gumble")} target="_blank" rel="noreferrer" data-testid="footer-stake"
                className="ml-1 inline-flex items-center gap-2 h-10 px-4 rounded-full bg-[#0A84FF] text-white text-[12.5px] font-semibold hover:bg-[#0077ED] transition-colors">
                Play on Stake
              </a>
            </div>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-widest text-white/40">Studio</div>
            <ul className="mt-4 space-y-2 text-[13.5px]">
              <li><Link to="/" className="text-white/70 hover:text-white">Games</Link></li>
              <li><Link to="/challenges" className="text-white/70 hover:text-white">Challenges</Link></li>
              <li><Link to="/news" className="text-white/70 hover:text-white" data-testid="footer-link-news">Journal</Link></li>
              <li><Link to="/partner" className="text-white/70 hover:text-white" data-testid="footer-link-partner">Partner with us</Link></li>
              <li><Link to="/faq" className="text-white/70 hover:text-white">FAQ</Link></li>
              <li><Link to="/privacy-policy" className="text-white/70 hover:text-white">Privacy</Link></li>
              <li><a href="/games/" className="text-white/70 hover:text-white">All games</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-widest text-white/40">Info</div>
            <div className="mt-4 space-y-2 text-[13.5px] text-white/50">
              <div>&copy; 2026 Gumble Studio</div>
              <div>18+ &mdash; Play responsibly</div>
              <div className="text-white/50">Powered by Stake Engine / RGS</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
